import React from 'react';
import styled from 'styled-components';
import { media } from '../../../../shared/lib/styles';
import Scrollable from '../../../../shared/components/Scrollable';
import { publicImageUrl } from '../../../lib/publicImageUrl';
import Heading from '../../../../shared/components/Heading';
import Image from '../../../../shared/components/Image';
import Attribution from '../../../../shared/components/Attribution';
import ImageBorderedBox from '../../../../shared/components/ImageBorderedBox';
import Columns, { Column } from '../../../../shared/components/Columns';
import HowItWorksCard from '../../HowItWorks/HowItWorksCard';

const StyledColumns = styled(Columns)`
    width: 100%;
    max-width: 1270px;
    min-width: 1014px;
    flex-shrink: 1;

    @media ${media('medium')} {
        min-width: 870px;
    }

    @media ${media('small')} {
        min-width: 840px;
    }
`;

interface Step {
    title: string;
    description: string;
    image?: {
        src: string;
        alt: string;
        attribution: string;
        width: number;
        height: number;
        scale?: number;
        offset?: [number, number];
    };
}

export interface HowItWorksProps {
    title: string;
    titleColor?: string;
    steps: Step[];
}

interface Props {
    config: HowItWorksProps;
}

function HowItWorksSection({ config }: Props) {
    const { title, titleColor, steps } = config;

    return (
        <>
            <div className="row">
                <div className="column">
                    <Heading
                        type="h2"
                        variations={['h2', 'with-divider']}
                        style={{ color: titleColor }}
                    >
                        {title}
                    </Heading>
                </div>
            </div>
            <Scrollable variations={['full-page-width']}>
                <StyledColumns>
                    {steps.map((step, index) =>
                        step.image ? (
                            <Column key={index}>
                                <HowItWorksCard
                                    stepNumber={`0${index + 1}`}
                                    title={step.title}
                                    description={step.description}
                                    image={
                                        <ImageBorderedBox
                                            image={
                                                <Image
                                                    src={publicImageUrl(step.image.src)}
                                                    alt={step.image.alt}
                                                    width={step.image.width}
                                                    height={step.image.height}
                                                />
                                            }
                                            attribution={
                                                step.image.attribution ? (
                                                    <Attribution name={step.image.attribution} />
                                                ) : null
                                            }
                                            scale={step.image.scale ? step.image.scale : 1}
                                            offset={step.image.offset}
                                        />
                                    }
                                />
                            </Column>
                        ) : null
                    )}
                </StyledColumns>
            </Scrollable>
        </>
    );
}

export default HowItWorksSection;
